import { normalizeNumber } from '../formatters';

export default function isCnpj(value) {
  const cnpj = normalizeNumber(value);
  let numbers;
  let digits;
  let sum;
  let i;
  let result;
  let pos;
  let size;
  let digits_iguais;
  digits_iguais = 1;
  if (cnpj.length < 14 && cnpj.length < 15) {
    return false;
  }

  for (i = 0; i < cnpj.length - 1; i++) {
    if (cnpj.charAt(i) != cnpj.charAt(i + 1)) {
      digits_iguais = 0;
      break;
    }
  }

  if (!digits_iguais) {
    size = cnpj.length - 2;
    numbers = cnpj.substring(0, size);
    digits = cnpj.substring(size);
    sum = 0;
    pos = size - 7;
    for (i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    if (result !== Number(digits.charAt(0))) {
      return false;
    }

    size += 1;
    numbers = cnpj.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    if (result != digits.charAt(1)) {
      return false;
    }
    return true;
  }
  return false;
}
